import React from 'react';
import credit from '@/seo/credit.json';

// Footer credit on public pages. Text lives in src/seo/credit.json so the
// prerender step prints the same line for crawlers.
export default function BuiltBy({ lang = 'en', className = '' }) {
  const [before, after] = (credit.templates[lang] || credit.templates.en).split('{name}');
  return (
    <p className={className}>
      {before}
      <a href={credit.href} className="hover:text-[#b45309] underline-offset-2 hover:underline transition-colors">
        {credit.localNames[lang] || credit.name}
      </a>
      {after}
    </p>
  );
}
